/**
 * v-stack-table — Bar Experts
 * Tabela vira lista de cartões no celular (< 768px): cada célula ganha o nome
 * da coluna (data-label), e o CSS em assets/main.css empilha as linhas.
 * Uso: <table class="table ..." v-stack-table>
 * Funciona com <thead><th> simples (sem colspan/rowspan).
 */
function label(table) {
  const headers = [...table.querySelectorAll('thead th')].map(th => th.textContent.trim())
  if (!headers.length) return
  table.setAttribute('data-stack', '')
  table.querySelectorAll('tbody tr').forEach(tr => {
    ;[...tr.children].forEach((cell, i) => {
      if (headers[i] && cell.getAttribute('data-label') !== headers[i]) {
        cell.setAttribute('data-label', headers[i])
      }
    })
  })
}

export const stackTable = {
  mounted: label,
  updated: label,
}
